import { Stack, Typography } from '@mui/material';
import Container from '@mui/material/Container';
import { useEffect, useState } from 'react';
import { Heading } from '../../components/Heading';
import { Spinner } from '../../components/Spinner';
import { getStatistics, MedalCategory } from '../../firebase/api';

export const MedalsPage = () => {
  const [categories, setCategories] = useState<
    readonly MedalCategory[] | undefined
  >(undefined);

  useEffect(() => {
    const fetchMedalWinners = async () => {
      const winners = await getStatistics();
      setCategories(winners);
    };

    fetchMedalWinners();
  }, []);

  return (
    <Container component="main" maxWidth="sm">
      <Stack gap={4} p={2}>
        <Heading>Medaljörer</Heading>

        {categories === undefined ? (
          <Spinner />
        ) : (
          <Stack gap={3}>
            {categories.map(({ title, description, topThree }) => (
              <div key={title}>
                <Typography variant="body1" fontWeight="bold">
                  {title}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {description}
                </Typography>
                {topThree.map((user, index) => (
                  <Typography
                    key={user}
                    variant={index === 0 ? 'body1' : 'body2'}
                    fontWeight={index === 0 ? 'bold' : 'normal'}
                  >
                    {index + 1}. {user}
                  </Typography>
                ))}
              </div>
            ))}
          </Stack>
        )}
      </Stack>
    </Container>
  );
};
